export default __webpack_public_path__ + "static/media/metamask-fox.7db94670.svg";